export enum TopicInitiativeType {
  APPLY_SEARCH_CRITERIA = "[Topic Initiatives] - Apply search criteria",
  CLEAR_SEARCH_CRITERIA = "[Topic Initiatives] - Apply clear criteria",
}

export type ApplyInitiativesSearchCriteriaAction = {
  payload: { limit?: number; offset?: number; search?: string } & Partial<Record<string, string | number | undefined>>;
  type: TopicInitiativeType.APPLY_SEARCH_CRITERIA;
};
export type ClearInitiativesSearchCriteriaAction = { type: TopicInitiativeType.CLEAR_SEARCH_CRITERIA };
